
import styled from "@emotion/styled";
import { Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import React from "react";

// Define the type for each step
export interface StepItem {
 label: string;
 description: string;
}

// Define the props for the component
interface VerticalStepperProps {
 steps: StepItem[];
}
const StyledStepper = styled(Stepper)(() => ({
  "& .MuiStepIcon-root.Mui-active": {
    color: "black",
  },
  "& .MuiStepIcon-root > .MuiStepIcon-text": {
    fill: "white",
  },
}));
const VerticalStepper: React.FC<VerticalStepperProps> = ({ steps }) => {
  return (
    <div>
      <StyledStepper
        orientation="vertical"
        nonLinear
      >
        {steps.map((step, index) => (
          <Step key={index} active>
            <StepLabel color="default"><h3 className="font-semibold">{step.label}</h3></StepLabel>
            <StepContent>
              <Typography>{step.description}</Typography>
            </StepContent>
          </Step>
        ))}

      </StyledStepper>
    </div>
  );
};

export default VerticalStepper;
